// extracted by mini-css-extract-plugin
export default {"thumbnail":"rB5Ib___IndexPage-module__thumbnail"};